<template>
  <div class="spnod-admin__form--container container pl-0 mx-0 d-flex flex-column">
    <b-form class="d-flex flex-column" @submit.stop.prevent>
      <b-form-input
        v-model="$v.form.name.$model"
        name="name"
        :state="validateState('name')"
        type="text"
        placeholder="Name"
        size="sm"
        class="mb-2"></b-form-input>
      <Multiselect
        v-model="form.sharedWith"
        :options="options"
        :multiple="true"
        :close-on-select="false"
        placeholder="Share with"
        track-by="_id"
        label="name"
        :group-select="true"
        group-values="values"
        group-label="label"
        class="mb-2">
      </Multiselect>
      <b-form-textarea
        v-model="$v.form.description.$model"
        name="description"
        :state="validateState('description')"
        type="text"
        rows="3"
        placeholder="Description"
        size="sm"
        class="mb-4">
      </b-form-textarea>
      <b-form-row class="d-flex justify-content-between px-1">
        <b-form-group>
          <b-button class="bg-danger" size="sm" v-b-modal="modals.delete._id">
            <p v-if="!isDeleting">Delete</p>
            <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </b-button>
        </b-form-group>
        <b-form-group class="d-flex justify-content-end flex-grow">
          <b-button class="spnod-admin__form--button" @click="$router.go(-1)" size="sm">Cancel</b-button>
          <b-button
            class="spnod-admin__form--button"
            size="sm"
            type="submit"
            :disabled="isDisabled"
            v-b-modal="modals.save._id">
            <p v-if="!isSaving">Save</p>
            <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </b-button>
        </b-form-group>
      </b-form-row>
    </b-form>

    <!--  Save Modal  -->
    <Modal
      :_id="modals.save._id"
      :message="modals.save.message"
      @success="handleSubmit" />

    <!--  Delete Modal  -->
    <Modal
      :_id="modals.delete._id"
      :message="modals.delete.message"
      @success="handleDelete" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { Multiselect } from 'vue-multiselect'
import Modal from '../Notifications/Modal'

export default {
  name: 'EditFileForm',
  components: { Multiselect, Modal },
  mixin: [validationMixin],
  data() {
    return {
      form: {
        name: '',
        description: '',
        sharedWith: []
      },
      modals: {
        save: {
          _id: 'modal-save',
          message: 'Are you sure you want to save?'
        },
        delete: {
          _id: 'modal-delete',
          message: 'Are you sure you want to delete this file?'
        }
      },
      options: [],
      isSaving: false,
      isDeleting: false
    }
  },
  computed: {
    ...mapGetters(['file', 'groups', 'users', 'getMyInfo']),
    isDisabled() {
      const anyBlanks = Object.entries(this.form).some(obj => obj[1] === '')
      return anyBlanks || this.$v.form.$anyError
    }
  },
  methods: {
    ...mapActions(['updateFile', 'deleteFile', 'getGroups', 'getUsers']),
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    handleSubmit: async function() {
      this.isSaving = true
      await this.updateFile(this.form)
      this.isSaving = false

      this.$router.push('/file')
    },
    handleDelete: async function() {
      this.isDeleting = true
      await this.deleteFile()
      this.$router.push('/file')
      this.isDeleting = false
    }
  },
  validations: {
    form: {
      name: { required },
      description: { required },
      file: { required }
    }
  },
  mounted: async function () {
    this.form.name = this.file.name
    this.form.description = this.file.description

    let users, groups

    if (this.getMyInfo.hasRoles) {
      if (this.file.owner._id !== this.getMyInfo._id) {
        // Nutritionist shouldn't see all users if they don't own the file
        users = { data: [this.getMyInfo] }
      } else {
        // Fetch first thousand Users & Groups for multiselect
        await this.getGroups({ page: 1, pageSize: 1000 })
        await this.getUsers({ page: 1, pageSize: 1000 })
        users = this.users
        groups = this.groups
      }
    } else {
      // Athletes can only share with Nutritionist
      users = { data: [this.getMyInfo.nutritionist.employee] }
    }

    const userOptions = { label: 'Users', values: [] }
    if (users && users.data) {
      users.data.forEach(u => {
        userOptions.values.push({
          name: u.name,
          _id: u._id,
          type: 'user'
        })
      })
    }

    const groupOptions = { label: 'Groups', values: [] }
    if (groups && groups.data) {
      groups.data.forEach(g => {
        groupOptions.values.push({
          name: g.name,
          _id: g._id,
          type: 'group'
        })
      })
    }

    this.options = [userOptions, groupOptions]

    // Define options that are already selected
    this.file.sharedWith.forEach(s => {
      if (s.client) {
        this.form.sharedWith.push({
          _id: s.client._id,
          name: s.client.name,
          type: 'user'
        })
      } else {
        this.form.sharedWith.push({
          _id: s.group._id,
          name: s.group.name,
          type: 'group'
        })
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Forms/EditFileForm.vue?213182aa